// SendEmailIncludedFieldsSection.jsx

import React from 'react';

// Utilities
import { getFieldLabel } from 'collection/automations/utils/automationFieldUtils';

// CSS
import './SendEmailIncludedFieldsSection.css';

// Components
import Checkbox from 'components/checkbox/Checkbox';
import ModalField from 'components/modal/field/ModalField';
import ModalLabel from 'components/modal/label/ModalLabel';

/**
 * SendEmailIncludedFieldsSection
 *
 * Renders selectable include-information fields for send-email actions.
 *
 * @param {object} theme - Theme object used for dynamic styling.
 * @param {array} emailBulletFieldOptions - Eligible field options for inclusion.
 * @param {array} effectiveIncludedFieldKeys - Currently included field keys.
 * @param {function} onToggleField - Toggles a field key in the include list.
 *
 * @returns {ReactNode} The rendered include-information section.
 */
const SendEmailIncludedFieldsSection = React.memo(({
  theme,
  emailBulletFieldOptions,
  effectiveIncludedFieldKeys,
  onToggleField,
}) => {

  // ----- RENDER ----- //

  return (
    <ModalField>
      <ModalLabel label="Include Information" />

      {/* FIELD GRID */}
      <div className="automation-email-field-grid">
        {emailBulletFieldOptions.map((field) => {
          const fieldKey = String(field?.key || '').trim();
          if (!fieldKey) return null;

          const checked = effectiveIncludedFieldKeys.includes(fieldKey);

          return (
            <label
              className="automation-email-field-option"
              key={fieldKey}
            >
              <Checkbox
                value={checked}
                size={18}
                onChange={(event) => {
                  event?.stopPropagation?.();
                  onToggleField(fieldKey);
                }}
              />
              <span
                style={{
                  color: theme.foreground,
                }}
              >
                {getFieldLabel(field)}
              </span>
            </label>
          );
        })}
      </div>
    </ModalField>
  );
});

// Dev Tools
SendEmailIncludedFieldsSection.displayName = 'SendEmailIncludedFieldsSection';

export default SendEmailIncludedFieldsSection;
